<div
  *ngIf="userDeviceInfo === 'pc'"
  (click)="onAddToCart()"
  class="select-all {{ userDeviceInfo }}"
  [class.disable]="this.productService.selectProducts.length === 0"
>
  <div>{{ productService.selectProducts.length }} items Add to cart</div>
</div>
